import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import { initErrorReporting } from './observability/errorReporting';
import './index.css';

// Before render, so a crash during the first paint is still reported.
// No-ops without VITE_SENTRY_DSN.
initErrorReporting();

createRoot(document.getElementById('root')).render(
<StrictMode>
    <App />
</StrictMode>
);
